import * as React from 'react'
import Page from '../../components/page/Page'
import {
  createStyles,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Theme,
  withStyles,
  WithStyles,
  withTheme,
  WithTheme
} from "@material-ui/core";
import {RouteComponentProps} from "@reach/router";
import MarginRow from "../../components/page/MarginRow";
import TitleBar from "../../components/TitleBar";
import {inject, observer} from "mobx-react";
import AccountStore from "../../stores/AccountStore";
import Account from "../../model/Account"
import {observable, when} from "mobx";
import Progress from "../../components/Progress";
import FormValidator from "../../components/form/FormValidator";
import TextFieldValidator from "../../components/form/TextFieldValidator";
import DialogButton from "../../components/form/DialogButton";
import ControlTower, {Routes} from "../../components/ControlTower";
import {
  AccountSize,
  AccountStatus,
  AccountType,
  ActivityType,
  CreateAccountInput,
  ModelAccountFilterInput,
  UpdateAccountInput
} from "../../API";
import Notify from "../../components/notify/Notify";
import UserStore from "../../stores/UserStore";
import Tracking from "../../components/Tracking";
import Visible from "../../components/Visible";
import config from 'react-global-configuration';
import TitleButton from "../../components/TitleButton";
import Confirm from "../../components/confirm/Confirm";
import ProgressButton from "../../components/form/ProgressButton";

const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'flex-start',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),

  },
  titleBar: {
    flexGrow: 1,
    justifyContent: "space-between",
    width: "100%",
    height: 40,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  message: {
    color: theme.palette.error.main,
    marginTop: 10
  },
  dialogPaper: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    width: '100%',
    // maxWidth: 480,
    marginTop: theme.spacing(1)
  },
  form: {
    width: '100%'
  },
  dialogContent: {
    padding: theme.spacing(1),
    "&:first-child": {
      paddingTop: 4
    }
  },
  dialogActions: {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    justifyContent: "center",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  dialogActionsGrid: {
    justifyContent: "space-evenly",
    width: "100%",
  },
  dialogTitle: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textAlign: 'center'
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    marginTop: theme.spacing(1),
    marginBottom: 0,
    marginLeft: 0,
  },
  radioGroup: {
    marginTop: 0
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    fontWeight: 'bold',
    letterSpacing: 0.7,
    // borderRadius: 2,
    marginTop: 0,
    paddingTop: 7,
    paddingBottom: 5,
    marginLeft: "0px",
    textTransform: "uppercase",
    "&:hover": {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.light,
    }
  },
  accountSelector: {
    width: "50%"
  }
})

interface IAccountEditPageProps {
  accountId?: string
  userStore?: UserStore
  accountStore?: AccountStore
  progress?: Progress
  notify?: Notify
  confirm?: Confirm
}

@inject("accountStore", "userStore", "progress", "notify", "confirm")
@observer
class AccountEditPage extends React.Component<WithStyles<typeof styles> & RouteComponentProps & IAccountEditPageProps & WithTheme> {

  @observable isLoading = true
  @observable account?: Account
  @observable values = {
    accountStatus: "Active",
    accountSize: "Small",
    accountName: "",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    customerId: ""
  }
  @observable message = ""
  @observable mergeAccount?: Account
  @observable accounts: Account[] = []
  @observable isSubmitting = false

  componentDidMount () {
    const { accountId, userStore, accountStore, progress} = this.props
    this.isLoading = true
    progress!.show("AccountEditPage")
    when(
      () => !userStore!.isLoading,
      async () => {
        if (accountId) {
          this.account = await accountStore!.getAccount(this.props.accountId!)
          if (this.account) {
            this.values = {
              accountName: this.account.name,
              accountStatus: this.account.accountStatus.toString(),
              accountSize: this.account.accountSize.toString(),
              address: this.account.address,
              city: this.account.city,
              state: this.account.state,
              postalCode: this.account.postalCode,
              customerId: this.account.customerId
            }
          }
          await this.loadAccounts()
        }
        this.isLoading = false
        progress!.hide("AccountEditPage")
      }
    )
  }


  render() {
    const { classes, userStore } = this.props

    const title = this.account ? "Edit Account" : "Add Account"
    const isAdmin = userStore!.isAdmin

    return (
      <Page title={title}>
        <MarginRow>
          <Grid container className={classes.root} direction="column">
            <TitleBar title={title} className={classes.titleBar}>
            </TitleBar>
            <Paper className={classes.dialogPaper}>
              <FormValidator autoComplete="off"
                             name="accountEditForm" id="accountEditForm" className={classes.form}>
                <DialogContent className={classes.dialogContent}>
                  <TextFieldValidator
                    autoFocus
                    margin="dense"
                    name="accountName"
                    label="Agency Name"
                    type="text"
                    variant="standard"
                    validators={{required:true}}
                    onChange={this.onChange}
                    value={this.values.accountName}
                    fullWidth
                    placeholder="Name of your agency"
                  />
                  <TextFieldValidator
                    margin="dense"
                    name="address"
                    label="Address"
                    type="text"
                    variant="standard"
                    validators={{required:false}}
                    onChange={this.onChange}
                    value={this.values.address}
                    fullWidth
                  />
                  <TextFieldValidator
                    margin="dense"
                    name="city"
                    label="City"
                    type="text"
                    variant="standard"
                    validators={{required:false}}
                    onChange={this.onChange}
                    value={this.values.city}
                    fullWidth
                  />
                  <TextFieldValidator
                    margin="dense"
                    name="state"
                    label="State"
                    type="text"
                    variant="standard"
                    validators={{required:false}}
                    onChange={this.onChange}
                    value={this.values.state}
                    fullWidth
                  />
                  <TextFieldValidator
                    margin="dense"
                    name="postalCode"
                    label="ZIP Code"
                    type="text"
                    variant="standard"
                    validators={{required:false}}
                    onChange={this.onChange}
                    value={this.values.postalCode}
                    fullWidth
                  />
                  <FormGroup>
                    <div className={classes.label}>Agency Size (number of responders)</div>
                    <RadioGroup aria-label="accountSize" name="accountSize" value={this.values.accountSize} onChange={this.onChange} row>
                      <FormControlLabel
                        value="Small"
                        control={<Radio color="secondary" />}
                        label="Small (1-49)"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Medium"
                        control={<Radio color="secondary" />}
                        label="Medium (50-199)"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Large"
                        control={<Radio color="secondary" />}
                        label="Large (200+)"
                        labelPlacement="end"
                      />
                    </RadioGroup>
                  </FormGroup>
                  <Visible if={isAdmin && this.account !== undefined}>
                    <div className={classes.label}>Status</div>
                    <RadioGroup aria-label="accountStatus" name="accountStatus" className={classes.radioGroup}
                                value={this.values.accountStatus} onChange={this.onChange} row>
                      <FormControlLabel
                        value="Active"
                        control={<Radio color="secondary"/>}
                        label="Active"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="Suspended"
                        control={<Radio color="secondary"/>}
                        label="Suspended"
                        labelPlacement="end"
                      />
                      <Visible if={this.values.accountStatus === AccountStatus.Deleted}>
                        <FormControlLabel
                          value="Deleted"
                          control={<Radio color="secondary"/>}
                          label="Deleted"
                          labelPlacement="end"
                          disabled={true}
                        />
                      </Visible>
                    </RadioGroup>
                    {this.values.customerId &&
                      <TextFieldValidator
                        margin="dense"
                        name="customerId"
                        label="Stripe Customer ID"
                        type="text"
                        variant="standard"
                        validators={{required:false}}
                        value={this.values.customerId}
                        fullWidth
                        disabled
                        InputProps={{endAdornment: <TitleButton title="OPEN" variant="secondary" onClick={this.onStripe}/>}}
                      />
                    }
                  </Visible>
                  <Visible if={isAdmin && this.account !== undefined && this.account.id !== userStore!.user!.accountId}>
                    <TextFieldValidator
                      type="text"
                      className={classes.accountSelector}
                      variant="standard"
                      name="account"
                      label="Merge to Account"
                      autocompleteOptions={{
                        options: this.accounts,
                        getOptionLabel: (option: Account) => option?.name,
                        getOptionSelected: (option: Account, value: Account) => option.id === value.id,
                        value: this.mergeAccount,
                        onChange: this.onSelectAccount,
                        disableClearable: false
                      }}
                    />
                  </Visible>
                <DialogContentText className={classes.message}>
                  {this.message}
                </DialogContentText>

                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                  <Grid container direction="row" className={classes.dialogActionsGrid}>
                    <Grid item xs={2}>
                      <Visible if={isAdmin && this.account !== undefined}>
                        <DialogButton variant="primary" onClick={this.onDelete} customClassName={classes.deleteButton}>
                          DELETE...
                        </DialogButton>
                      </Visible>
                    </Grid>
                    <Grid item xs={8} style={{display:"flex", justifyContent:"center"}}>
                      <DialogButton variant="secondary" onClick={this.onCancel}>
                        CANCEL
                      </DialogButton>
                      <div style={{flexGrow:0, width:10}}/>
                      <ProgressButton variant="contained" color="secondary"
                                      processing={this.isSubmitting}
                                      onClick={this.onSubmit}>
                        SAVE
                      </ProgressButton>
                    </Grid>
                    <Grid item xs={2}>

                    </Grid>
                  </Grid>
                </DialogActions>
              </FormValidator>
            </Paper>
          </Grid>
        </MarginRow>
      </Page>
    )
  }

  async loadAccounts() {
    const { accountStore, userStore } = this.props
    if (userStore!.user?.isAdmin && this.account) {
      // Filter only active accounts and exclude current account
      const filter: ModelAccountFilterInput = {
        and: [
          {accountStatus: {eq: AccountStatus.Active} },
          { id: {ne: this.account.id} }
        ]
      }
      const accounts: Account[] = await accountStore!.listAccounts(filter)
      const sorted = accounts.sort((a: Account, b: Account) => a.name.localeCompare(b.name))
      this.accounts = sorted
    } else {
      this.accounts = []
    }
  }

  onSelectAccount = async (event: any, value: any, reason: any) => {
    this.mergeAccount = value as Account
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name
    this.values[name] = event.target.value
  }

  onCancel = () => {
    const { accountId, notify } = this.props
    notify!.close()

    if (ControlTower.currentRoute.startsWith(Routes.accountsEdit)) {
      ControlTower.route(`${Routes.accounts}`)
    } else {
      ControlTower.route(`${Routes.account}/${accountId}/info`)
    }
  }

  onSubmit = async () => {
    const { accountId, accountStore, userStore, notify, confirm } = this.props
    notify!.close()

    this.isSubmitting = true

    const values = this.values

    if (accountId) {
      Tracking.event({action: 'UpdateAccount'})
      const input: UpdateAccountInput = {
        id: accountId!,
        accountType: AccountType.Agency,
        accountStatus: (AccountStatus as any)[values.accountStatus],
        accountSize: AccountSize[values.accountSize],
        name: values.accountName,
        address: values.address,
        city: values.city,
        state: values.state,
        postalCode: values.postalCode
      }
      const update = await accountStore!.updateAccount(input)
        .catch((err: Error) => {
          notify!.show("error", "Unable to update account")
        })

      if (update && this.mergeAccount) {
        confirm!.show("Confirm Merge",
          `Please confirm you want to merge "${this.account!.name}" into "${this.mergeAccount.name}"`,
          ["Confirm", "Cancel"],
            async () => {
              const merged = await accountStore!.mergeAccounts(this.account!, this.mergeAccount!)
                .catch((err: Error) => {
                notify!.show("error", err.message)
              })
              if (merged) {
                notify!.show("success", "Account merged!")
                ControlTower.route(Routes.accounts)
              }
              return true
          },
          () => {
            notify!.show("success", "Account updated!")
            this.onCancel()
          })
      } else if (update) {
        notify!.show("success", "Account updated!")
        this.onCancel()
      }
    } else {
      Tracking.event({action: 'CreateAccount'})
      const input: CreateAccountInput = {
        id: accountId!,
        accountType: AccountType.Agency,
        accountStatus: (AccountStatus as any)[values.accountStatus],
        name: values.accountName,
        address: values.address,
        city: values.city,
        state: values.state,
        postalCode: values.postalCode
      }
      const account = await accountStore!.createAccount(input)
        .catch((err: Error) => {
          notify!.show("error", "Unable to create account")
        })

      if (account) {
        notify!.show("success", "Account created!")
        if (userStore!.isAdmin) {
          await accountStore!.init(account)
        }
        userStore!.createActivity(ActivityType.AccountCreate, account.id)
        ControlTower.route(`${Routes.account}/${account.id}`)
      }
    }

    this.isSubmitting = false
  }

  onStripe = async() => {
    if (this.account!.customerId) {
      const env = config.get("branch") === "master" ? "live" : "test"
      ControlTower.open(`https://dashboard.stripe.com/${env}/customers/${this.account!.customerId}`, '_blank')
    }
  }

  onDelete = async() => {
    const { accountStore, notify, confirm } = this.props
    notify!.close()

    if (this.account) {
      confirm!.show("Confirm Delete",
        `Are you sure you wish to delete this account (${this.account.name})? NOTE: If it has users or classes, then it will be soft deleted`,
        ["Confirm", "Cancel"],
        async () => {
          const account = await accountStore!.deleteAccount(this.account!)
            .catch((err: Error) => {
              notify!.show("error", err.message)
            })

          if (account) {
            const option = (account.accountStatus === AccountStatus.Deleted) ? "soft " : ""
            notify!.show("success", `Account has been ${option}deleted.`)
            ControlTower.route(Routes.accounts)
          }
          return true
        },
        () => {
          // Do nothing
        })
    }

  }

}

export default withTheme((withStyles(styles)(AccountEditPage)))